"use strict";
exports.__esModule = true;
var GTagEvent;
(function (GTagEvent) {
    GTagEvent["SHOW_BANNER"] = "show_product_banner";
    GTagEvent["SHOW_PAYMENT_METHOD_DESCRIBE"] = "show_payment_method_description";
    GTagEvent["SHOW_HOW_IT_WORKS"] = "show_how_it_works";
})(GTagEvent || (GTagEvent = {}));
exports["default"] = GTagEvent;
